import { useNavigate } from "react-router";
import { getConfiguredLabel } from "../../common/commonHelper";
import { DocumentsPage, uploadButton } from "../../common/labelConstants";
import SlbButton from "../controls/button";

export function UploadButton() {
    const navigate = useNavigate();
    const handleUploadButton = () => {
        navigate('/upload')
    }
    return <>
        <SlbButton className='calcel_btn ' onClick={handleUploadButton}>
            <span className='DisFlex upload_btn' onClick={handleUploadButton}>
            <span className="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 23.995">
                    <g id="Upload" transform="translate(-42.8 -42.692)">
                        <path id="Path_22" fill="#3265aa" data-name="Path 22" d="M136.317,43.041a.141.141,0,0,0-.039-.023,1.087,1.087,0,0,0-.354-.236h-.006a1.205,1.205,0,0,0-1.3.259l-5.99,6a1.2,1.2,0,0,0,1.693,1.7l3.954-3.948V60.7a1.2,1.2,0,1,0,2.4,0V46.787l3.954,3.948a1.2,1.2,0,0,0,1.7-1.693Z" transform="translate(-80.677)"/>
                        <path id="Path_23" fill="#3265aa" data-name="Path 23" d="M64.393,321.2v3.6a1.2,1.2,0,0,1-1.2,1.2h-16.8a1.2,1.2,0,0,1-1.2-1.2v-3.6a1.2,1.2,0,1,0-2.4,0v3.6a3.6,3.6,0,0,0,3.6,3.6H63.2a3.6,3.6,0,0,0,3.6-3.6v-3.6a1.2,1.2,0,0,0-2.407,0Z" transform="translate(0 -261.71)"/>
                    </g>
                </svg>
            </span>
            {getConfiguredLabel(DocumentsPage, uploadButton)}
            </span>
        </SlbButton>
    </>
}